'use client';

import { useEffect } from 'react';
import type { MarketingValues } from './campaign';

/**
 * Bootstraps the third-party marketing scripts and mirrors the campaign attribution onto
 * `window.JLG.marketing`, which the vanilla scripts in `lib/marketing/` and the external
 * analytics project read. React code reads the same values through `useMarketing` instead.
 *
 * Rendered by `MarketingProvider`, never directly: it must be handed the effective offer id.
 *
 * Every snapshot is handed over, the one a navigation to another campaign produces included —
 * the vendors would otherwise keep reporting the page the visitor landed on. Booting them
 * exactly once is `lib/marketing/index.js`'s job: the App Router remounts this component on
 * every navigation, so a guard kept here would be reset by the very thing it has to survive.
 *
 * The effect is keyed on the snapshot's identity, which `MarketingProvider` memoises on the
 * values — a re-render that changes nothing does not reach the vendors.
 */
export default function MarketingScripts({ marketing }: { marketing: MarketingValues }) {
  useEffect(() => {
    import('@/lib/marketing/index').then((Scripts) => {
      Scripts.run(marketing);
    });
  }, [marketing]);

  return <></>;
}
